import React from "react";
import "./GallerySlider.css";

import img1 from "../../assets/Image/NewImages/A.jpeg";
import img2 from "../../assets/Image/NewImages/CarrierRoadMap.jpeg";
import img3 from "../../assets/Image/NewImages/B.jpeg";
import img4 from "../../assets/Image/NewImages/InteractiveCarrier.jpeg";
import img5 from "../../assets/Image/NewImages/C.jpeg";
import img6 from "../../assets/Image/NewImages/PersonalGuidance.jpeg";
import img7 from "../../assets/Image/NewImages/D.jpeg";
import img8 from "../../assets/Image/NewImages/p_img5.jpeg";
import img9 from "../../assets/Image/NewImages/p_img4.jpeg";
import img10 from "../../assets/Image/NewImages/Sam_banner3.jpg";

function GallerySlider() {
  const images = [
    { src: img1 },
    { src: img2 },
    { src: img3 },
    { src: img4 },
    { src: img5 },
    { src: img6 },
    { src: img7 },
    { src: img8 },
    { src: img9 },
    { src: img10 },
  ];

  const sliderImages = [...images, ...images];

  return (
    <section className="gallery-section">
      <h2 className="gallery-title">Our Gallery</h2>

      <div className="gallery-slider">
        <div className="gallery-track">
          {sliderImages.map((img, index) => (
            <div className="gallery-item" key={index}>
              <img src={img.src} alt="gallery" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default GallerySlider;
